package com.devi3east.bashbuddy.purchase.domain.models

import kotlinx.serialization.Serializable

@Serializable
enum class SubPurchaseStatus {
    INITIATED,
    REQUIRES_PAYMENT,
    PAID,
    CANCELED
}